import { useDeviceStore } from "@/store/device";
import { useStakingStore } from "@/store/staking";
import { useUserStore } from "@/store/user";
import { fetchUserThirdPartyCoStakedDevices } from "@/utils/staking";

export async function checkUserHasWorkers(): Promise<boolean> {
  const userId = useUserStore.getState().userId;
  if (!userId) {
    return false;
  }

  const { resultCount, results } = await useDeviceStore.getState().fetchDevicesRequest({
    type: "worker",
    page: 1,
    limit: 1
  });

  return (resultCount ?? results.length) > 0;
}

export async function checkUserHasStakingActivity(): Promise<boolean> {
  const userId = useUserStore.getState().userId;
  if (!userId) {
    return false;
  }

  const [stakedDevices, coStakedOffers] = await Promise.all([
    useStakingStore.getState().fetchUserStakedDevicesRequest({ page: 1, limit: 1 }),
    fetchUserThirdPartyCoStakedDevices({ userId, limit: 1 })
  ]);

  return stakedDevices.results.length > 0 || coStakedOffers.resultCount > 0;
}

export async function fetchUserDashboardMenuVisibility(): Promise<{
  hasWorkers: boolean;
  hasStaking: boolean;
}> {
  const [hasWorkers, hasStaking] = await Promise.all([
    checkUserHasWorkers(),
    checkUserHasStakingActivity()
  ]);

  return { hasWorkers, hasStaking };
}
